import React from 'react';
import PagedView from 'Shared/components/PagedView/PagedView';
import {useDispatch, useSelector} from 'react-redux';
import {getEnrollmentFiles, changeEnrollmentFileFilters} from '../../ducks/enrollmentFileProcessing';
import Column from 'Shared/components/PagedView/Column';
import {withStringFilterProperties, withSelectFilterProperties} from 'Shared/components/PagedView/Filter';
import {EMWEnrollmentFile} from 'Enrollment/models/EnrollmentFile';
import {Page} from 'Core/models/Page';
import {AsyncPage} from 'Core/models/Async';
import {Link} from 'react-router-dom';
import {Button} from '@material-ui/core';
import {EnrollmentRouteConstants} from 'Enrollment/Routes';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import * as EnrollmentFileActions from 'Enrollment/ducks/enrollmentFileProcessing';
import {ReducerState} from 'rootReducer';

type EMWEnrollmentFileProps = {
  enrollmentFilesData: AsyncPage<Page<EMWEnrollmentFile>>;
};

const EMWEnrollmentFilesTable = (props: EMWEnrollmentFileProps) => {
  const dispatch = useDispatch();
  const {enrollmentFilesFilter} = useSelector((state: ReducerState) => state.enrollmentFileProcessing);
  const changeFilter = withValueChangedHook(
    enrollmentFilesFilter as EnrollmentFileActions.EMWEnrollmentFileFilters,
    changeEnrollmentFileFilters,
    dispatch
  );
  const filterProperties = {
    changeFilter,
    filterData: enrollmentFilesFilter as EnrollmentFileActions.EMWEnrollmentFileFilters,
  };
  const statusOptions = [
    {
      name: 'Ok',
      value: 'Ok',
    },
    {
      name: 'Warning',
      value: 'Warning',
    },
    {
      name: 'Critical',
      value: 'Critical',
    },
  ];

  return (
    <PagedView
      pagedViewKey="emwEnrollmentFilesTable"
      data={props.enrollmentFilesData}
      loadMore={page => dispatch(getEnrollmentFiles(page, enrollmentFilesFilter))}
    >
      {columnProps => (
        <>
          <Column
            {...columnProps}
            title="Agency Name"
            default
            filterProperties={withStringFilterProperties(filterProperties, 'agencyName')}
          >
            {enrollmentFile => enrollmentFile.agencyName}
          </Column>
          <Column
            {...columnProps}
            title="Case Number"
            default
            filterProperties={withStringFilterProperties(filterProperties, 'caseNumber')}
          >
            {enrollmentFile => enrollmentFile.caseNumber}
          </Column>
          <Column
            {...columnProps}
            title="Enrollment Period Name"
            default
            filterProperties={withStringFilterProperties(filterProperties, 'enrollmentPeriodName')}
          >
            {enrollmentFile => enrollmentFile.enrollmentPeriodName}
          </Column>
          <Column
            {...columnProps}
            title="Buisness Status"
            default
            filterProperties={withSelectFilterProperties(filterProperties, 'businessStatus', statusOptions)}
          >
            {enrollmentFile => enrollmentFile.businessStatus}
          </Column>
          <Column
            {...columnProps}
            title="IT Status"
            default
            filterProperties={withSelectFilterProperties(filterProperties, 'itStatus', statusOptions)}
          >
            {enrollmentFile => enrollmentFile.itStatus}
          </Column>
          <Column {...columnProps} title="Actions" default>
            {enrollmentFile => (
              <Link to={EnrollmentRouteConstants.ENROLLMENT_FILE_DETAILS(enrollmentFile.id!)}>
                <Button id='emwEnrollmentFilesTable-action-button' className="primary-action-button" color="primary">
                  View Details
                </Button>
              </Link>
            )}
          </Column>
        </>
      )}
    </PagedView>
  );
};
export default EMWEnrollmentFilesTable;
